import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  RouteObject,
} from "react-router-dom";
import * as pageRoutes from "../../pages";
import { getTokenUseCase } from "../../features/auth/use-cases";
import { RootLayout } from "../RootLayout";

/**
 * 인증된 사용자만 접근 가능한 라우트 컴포넌트
 */
const ProtectedRoute = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  const token = getTokenUseCase.getAccessToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

/**
 * 공개 라우트 경로들
 */
const PUBLIC_ROUTES = [
  "/login",
  "/",
  "/subscription",
  "/subscription/checkout",
  "/subscription/checkout/result",
  "/payment/result",
  "/subscription/result",
  "/about",
  "/service",
  "/support",
  "/franchise-inquiry",
  "/signup",
  "/account-recovery",
  "/free-trial",
  // "/downloads",
];

/**
 * pages 폴더에서 내보낸 모든 라우트를 수집 (children 라우트 포함)
 */
const getAllRoutes = (): RouteObject[] => {
  const routes: RouteObject[] = [];

  for (const key in pageRoutes) {
    const value = (pageRoutes as Record<string, any>)[key];
    // RouteObject 타입인지 확인
    if (
      value &&
      typeof value === "object" &&
      "path" in value &&
      "element" in value
    ) {
      routes.push(value as RouteObject);
    }
  }

  return routes;
};

/**
 * 애플리케이션 라우터
 * FSD (Feature-Sliced Design) 구조로 구성
 * pages 폴더에서 자동으로 라우트를 수집합니다
 */
export const AppRouter = () => {
  const allRoutes = getAllRoutes();

  const renderRoute = (route: RouteObject): React.ReactElement => {
    const isPublic = PUBLIC_ROUTES.includes(route.path as string);

    console.log("Rendering route:", route.path, "Is public:", isPublic);

    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          isPublic ? (
            (route.element as React.ReactElement)
          ) : (
            <ProtectedRoute>{route.element}</ProtectedRoute>
          )
        }
      >
        {route.children &&
          route.children.map((childRoute) => renderRoute(childRoute))}
      </Route>
    );
  };

  return (
    <BrowserRouter>
      <RootLayout>
        <Routes>
          {allRoutes.map((route) => renderRoute(route))}

          {/* 정의되지 않은 경로는 홈으로 리다이렉트 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </RootLayout>
    </BrowserRouter>
  );
};
